"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentType = void 0;
var ContentType;
(function (ContentType) {
    ContentType["VIDEO"] = "video";
    ContentType["WEB"] = "web";
})(ContentType || (exports.ContentType = ContentType = {}));
